import * as React from 'react';
import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Icon from './Icon';
import Translate from './Translate';
import _FilterItem from './FilterItem';
import ClearFilters from './ClearFilters';
import { FilterStore, DataStore } from '../stores';
import { computed } from 'mobx';
import withFilter from './withFilter';

const FilterItem = withFilter(_FilterItem);

const FiltersMask = styled<any, any>('div')`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
`;

const FiltersWrapper = styled<any, any>('aside')`
    ${propStyles};
    position: absolute;
    top: 0;
    bottom: 0;
    transition: transform 200ms ease-in;
    transform: translate3d(-100%, 0, 0);
    &.open {
        transform: translate3d(0, 0, 0);
    }
`;

FiltersWrapper.defaultProps = {
    display: 'flex',
    flexDirection: 'column',
    zIndex: 'modal',
    width: '240px',
    bgColor: ['gray100', 'gray100', 'transparent'],
    fontSize: 'sm',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: ['none solid none none', 'none solid none none', 'none'],
};

const FiltersWrapperInner = styled<any, any>('div')`
    ${propStyles};
`;

FiltersWrapperInner.defaultProps = {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    overflowX: 'hidden',
};

const FiltersHeader = styled<any, any>('h3')`
    ${propStyles};
    flex-shrink: 0;
`;

FiltersHeader.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: 'body',
    bgColor: ['gray300', 'gray300', 'transparent'],
    margin: ['0', '0', '24px 0 0 0'],
    paddingY: 'md',
    paddingX: 'md',
};

const FiltersHeaderToggle = styled<any, any>('button')`
    ${propStyles};
    outline: none;
    cursor: pointer;
`;

FiltersHeaderToggle.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    flex: '1 0 auto',
    fontFamily: 'heading',
    fontWeight: 'medium',
    fontSize: 'inherit',
    color: 'body',
    bgColor: 'transparent',
    borderStyle: 'none',
};

interface FiltersProps {
    theme?: { [property: string]: string | number };
    filterStore?: FilterStore;
    dataStore?: DataStore;
    isMobile: boolean;
}

@inject('filterStore')
@inject('dataStore')
@observer
class Filters extends Component<FiltersProps> {
    // Filters are always open when above mobile size
    @computed
    get filtersOpen(): boolean {
        return !this.props.isMobile || this.props.filterStore.filtersOpen;
    }

    render() {
        const { theme, filterStore } = this.props;
        const { filtersOpen } = this;

        return (
            <FiltersMask>
                <FiltersWrapper
                    className={filtersOpen ? 'open' : ''}
                    {...theme.FiltersWrapper}
                >
                    <FiltersHeader {...theme.FiltersHeader}>
                        <FiltersHeaderToggle
                            onClick={filterStore.toggleFilters}
                            {...theme.FiltersHeaderToggle}
                        >
                            <Icon
                                fileName="FiltersHeaderToggleIcon"
                                display={['block', 'block', 'none']}
                                {...theme.FiltersHeaderToggleIcon}
                            />
                            <Translate>Filters</Translate>
                        </FiltersHeaderToggle>
                        {filterStore.filtersActive && (
                            <ClearFilters fontSize="xs" />
                        )}
                    </FiltersHeader>
                    <FiltersWrapperInner {...theme.FiltersWrapperInner}>
                        {filterStore.filters.map(filter => (
                            <FilterItem key={filter.property} filter={filter} />
                        ))}
                    </FiltersWrapperInner>
                </FiltersWrapper>
            </FiltersMask>
        );
    }
}

export default withTheme(Filters);



// WEBPACK FOOTER //
// ./src/Components/Filters.tsx